/* FluffCo Money — global currency localization helper.
 *
 * Shopify Markets exposes the active presentment currency + USD rate via
 * `window.Shopify.currency = { active: "HKD", rate: "7.8" }`. This helper
 * wraps that into a single formatter so every hardcoded USD price in the
 * theme can localize without per-page logic.
 *
 * Usage:
 *   - Liquid:  <span data-fc-usd="69"></span>           → hydrates on load
 *   - Liquid:  <span data-fc-usd-cents="6900"></span>   → hydrates on load
 *   - JS:      window.fluffcoMoney(69)                  → "HK$540" (etc)
 *   - Rerun:   document.dispatchEvent(new Event('fluffco:rehydrate-money'))
 *
 * Notes:
 *   - The "base" of every hardcoded number is USD (that's how the theme is
 *     authored). Shopify.currency.rate is USD→active.
 *   - For carts/checkout, Shopify's own money filter and cart.js fields are
 *     already in the active currency — don't double-convert.
 */
(function () {
  // Prefer Shopify's own geo-detected currency object (most accurate), then
  // fall back to our server-computed FluffCoCurrency namespace.
  function getRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      var r = parseFloat(window.Shopify.currency.rate);
      if (!isNaN(r) && r > 0) return r;
    }
    if (window.FluffCoCurrency && window.FluffCoCurrency.rate) {
      var r2 = parseFloat(window.FluffCoCurrency.rate);
      if (!isNaN(r2) && r2 > 0) return r2;
    }
    return 1;
  }
  function getCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return String(window.Shopify.currency.active);
    }
    if (window.FluffCoCurrency && window.FluffCoCurrency.active) {
      return String(window.FluffCoCurrency.active);
    }
    return 'USD';
  }

  // Format a USD amount in the active presentment currency.
  // For amounts >= 100 we drop decimals (cleaner display); below 100 we keep
  // two decimals because rounded fractions matter (e.g. $34 → ¥5,304 not ¥5,300).
  function format(usdAmount, opts) {
    var rate = getRate();
    var code = getCode();
    var n    = parseFloat(usdAmount);
    if (isNaN(n)) return '';
    var converted = n * rate;
    var decimals  = (opts && opts.decimals != null)
      ? opts.decimals
      : (Math.abs(converted) >= 100 ? 0 : 2);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
      }).format(converted);
    } catch (e) {
      // Currency code unknown to Intl — fall back to symbol-less rounded
      return code + ' ' + Math.round(converted);
    }
  }

  function hydrate(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fc-usd]').forEach(function (el) {
      var amt = parseFloat(el.getAttribute('data-fc-usd'));
      if (!isNaN(amt)) el.textContent = format(amt);
    });
    scope.querySelectorAll('[data-fc-usd-cents]').forEach(function (el) {
      var c = parseFloat(el.getAttribute('data-fc-usd-cents'));
      if (!isNaN(c)) el.textContent = format(c / 100);
    });
  }

  window.fluffcoMoney         = format;
  window.fluffcoHydrateMoney  = hydrate;
  window.fluffcoCurrencyCode  = getCode;
  window.fluffcoCurrencyRate  = getRate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(); });
  } else {
    hydrate();
  }
  document.addEventListener('fluffco:rehydrate-money', function () { hydrate(); });
})();
